<div
  class="flex h-full w-fit cursor-pointer flex-col overflow-hidden rounded-md"
  (click)="showPopup.set(true)"
>
  <div class="flex h-full items-center">
    <div class="relative h-full w-fit">
      <video
        [src]="guidance().video"
        class="relative h-full w-52 rounded-md object-cover"
      ></video>
      <div class="absolute -right-8 top-0 flex h-full flex-col justify-center">
        <div
          class="flex size-16 items-center justify-center rounded-full bg-bo-red shadow-lg"
        >
          <svg-icon
            src="icons/play.svg"
            class="fill-bo-white pl-1"
            [svgStyle]="{ 'height.px': 24 }"
          />
        </div>
      </div>
    </div>

    <div class="bo-subheader pl-[2.4rem] !text-bo-black">
      {{ guidance().name }}
    </div>
  </div>
</div>

@if (showPopup()) {
  <bo-video-popup [(isVisible)]="showPopup" [guidance]="guidance()" />
}
